import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { ClienteGrupoEconomicoSituacaoPipe } from './cliente-grupo-economico-situacao.pipe';
import { ClienteGrupoEconomicoSituacaoBadgePipe } from './cliente-grupo-economico-situacao-badge.pipe';


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteGrupoEconomicoSituacaoPipe,
        ClienteGrupoEconomicoSituacaoBadgePipe
    ],
    exports: [
        SharedModule,

        ClienteGrupoEconomicoSituacaoPipe,
        ClienteGrupoEconomicoSituacaoBadgePipe
    ],
    providers: [
        ClienteGrupoEconomicoSituacaoPipe,
        ClienteGrupoEconomicoSituacaoBadgePipe
    ]
})
export class ClienteGrupoEconomicoPipeSharedModule { }
